import Flex from "app/components/UI/Flex";
import ImmutablePropTypes from "react-immutable-proptypes";
import ProductListItem from "app/components/ProductListItem";
import PropTypes from "prop-types";
import React from "react";
import Spinner from "app/components/UI/Spinner";
import classes from "./ProductList.module.css";

export const ProductList = ({ clubId, isLoading, products, intl }) =>
  isLoading ? (
    <Spinner absolute />
  ) : (
    <Flex direction="row" wrap className={classes.productList} start>
      {products.map(product => (
        <ProductListItem
          key={product.get("@id")}
          clubId={clubId}
          product={product}
          productPublicMetadata={product.get("publicMetadata")}
        />
      ))}
    </Flex>
  );

ProductList.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  clubId: PropTypes.string.isRequired,
  products: ImmutablePropTypes.listOf(ImmutablePropTypes.map).isRequired
};

export default ProductList;



// WEBPACK FOOTER //
// ./src/app/components/ProductList/ProductList.js